import { BusinessDTO, MemberRol } from "../Types-DTOs/ClientUser";
import { ClientUserDTO } from "../Types-DTOs/ClientUser";

/**
 * Checks if the current user is an administrator (OWNER or ADMINISTRATIVE role)
 * @param business - The business object containing members
 * @param currentUser - The current logged-in user
 * @returns true if the user is an admin, false otherwise
 */
export const isAdmin = (business: BusinessDTO | undefined, currentUser: ClientUserDTO | undefined): boolean => {
  if (!business || !currentUser) {
    return false;
  }

  const currentMember = business.members.find(
    (member) => member.client?.id === currentUser.id
  );

  if (!currentMember) {
    return false;
  }

  return (
    currentMember.rol === MemberRol.OWNER ||
    currentMember.rol === MemberRol.ADMINISTRATIVE
  );
};



